import * as actions from '../utils/Constants';
import { apiGet, apiPost, apiRequest, apiDeleteWithBodyAndThen, Methods } from '../utils/Api';

const url = `${process.env.REACT_APP_API_HOST}api/contacts/`;

export const getContacts = () => ({
    type: actions.GET_CONTACTS,
    payload: apiPost(url, { searchTerm: null })
});

export const toggleContactNameValidState = (value) => ({
    type: actions.TOGGLE_PERSON_CONTACT_NAME_IS_VALID,
    payload: value
})

export const toggleContactsFlipState = (personId, isFlipped) => {
    if (!isFlipped)
        return dispatch =>
            dispatch({
                type: actions.TOGGLE_CONTACTS_FLIP_STATE,
                payload: apiRequest(`${process.env.REACT_APP_API_HOST}api/contacts/${personId}/details`, Methods.get, null, dispatch).then(x => { return { personId, ...x } })
            });
    else {
        return {
            type: actions.TOGGLE_CONTACTS_FLIP_STATE,
            payload: personId
        };
    }
};

export const getCourse = (id) => {
    return dispatch => dispatch({
        type: actions.GET_COURSE,
        payload: apiRequest(`${process.env.REACT_APP_API_HOST}api/course/${id}`, Methods.get, null, dispatch)
    });
};

export const newContact = (personTypeId) => ({
    type: actions.NEW_CONTACT,
    payload: personTypeId
});

export const clearContacts = () => ({
    type: actions.CLEAR_CONTACTS
});

export const setSearchCriteria = (e) => ({
    type: actions.SET_CONTACT_ADVANCED_SEARCH_CRITERIA,
    field: e.target.name,
    payload: e.target.value
});

export const setSearchCriteriaState = (e) => ({
    type: actions.SET_CONTACT_ADVANCED_SEARCH_CRITERIA,
    field: e.target.name,
    payload: parseInt(e.target.value, 10)
});

export const setSearchCriteriaDailyRateRange = (e, value) => ({
    type: actions.SET_CONTACT_ADVANCED_SEARCH_CRITERIA,
    field: 'dailyRateRange',
    payload: value
});

export const setSearchCriteriaDisciplines = (value) => ({
    type: actions.SET_CONTACT_ADVANCED_SEARCH_CRITERIA,
    field: 'disciplines',
    payload: value.map(x => parseInt(x, 10))
});

export const setSearchIsActive = (value) => ({
    type: actions.SET_CONTACT_ADVANCED_SEARCH_CRITERIA,
    field: 'isActive',
    payload: value
});

export const setSearchCriteriaCourtTypes = (value) => ({
    type: actions.SET_CONTACT_ADVANCED_SEARCH_CRITERIA,
    field: 'courtTypes',
    payload: value.map(x => parseInt(x, 10))
});

export const clearSearchCriteria = () => ({
    type: actions.CLEAR_CONTACT_SEARCH_CRITERIA,
});

export const clearAdvancedSearchCriteria = () => ({
    type: actions.CLEAR_CONTACT_SEARCH_ADVANCED_CRITERIA,
});

export const setSearchCriteriaPersonTypeId = (value) => ({
    type: actions.SET_CONTACT_SEARCH_CRITERIA,
    field: 'personTypeId',
    payload: value
});

export const getDailyRatesMinMax = () => ({
    type: actions.GET_DAILYRATES_MIN_MAX,
    payload: apiRequest(`${process.env.REACT_APP_API_HOST}api/contacts/DailyRatesMinMax`)
});

export const searchContacts = (searchTerm, personTypeId, advancedCriteria, showInactiveContacts) => {
    return {
        type: actions.GET_CONTACTS,
        payload: apiPost(url, { searchTerm, personTypeId, ...(advancedCriteria || {}), showInactiveContacts })
    }
};

export const setContactInactive = (personId, searchTerm, personTypeId, advancedCriteria, showInactiveContacts) => {
    return dispatch => apiRequest(`${process.env.REACT_APP_API_HOST}api/contacts/SetContactInactive/${personId}`, Methods.post, null, dispatch).then(() => {
        dispatch(searchContacts(searchTerm, personTypeId, advancedCriteria, showInactiveContacts));
    });
}

export const setContactActive = (personId, searchTerm, personTypeId, advancedCriteria, showInactiveContacts) => {
    return dispatch => apiRequest(`${process.env.REACT_APP_API_HOST}api/contacts/SetContactActive/${personId}`, Methods.post, null, dispatch).then(() => {
        dispatch(searchContacts(searchTerm, personTypeId, advancedCriteria, showInactiveContacts));
    });
}

export const deleteContact = (personId, searchTerm, personTypeId, advancedCriteria, showInactiveContacts) => {
    return dispatch => apiRequest(`${url}${personId}`, Methods.delete, null, dispatch).then(() => {
        dispatch(searchContacts(searchTerm, personTypeId, advancedCriteria, showInactiveContacts));
    });
}

export const deleteContacts = (ids = []) => {
    return dispatch => {
        return apiRequest(
            url,
            Methods.delete,
            ids,  
            dispatch
        ).then(() => {
            dispatch(getContacts());
        });
    };
}